/**
 * External dependencies
 */
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';

/**
 * Internal dependencies
 */
import initialReducer from './reducer';
import navigationMiddleware from "./navigation/middleware";
import noticesMiddleware from './notices/middleware';

/**
 * [createReduxStore description]
 * 
 * @param  {[type]} initialState [description]
 * @param  {[type]} reducer      [description]
 * @return {[type]}              [description]
 */
export function createReduxStore(initialState, reducer = initialReducer) {

    const middlewares = [
        thunkMiddleware,
        noticesMiddleware,
        // always last
        navigationMiddleware,
    ];

    const enhancers = [
        applyMiddleware(...middlewares),

    ];

    return createStore(
        reducer,
        initialState,
        composeWithDevTools(...enhancers)
    );

}